/** French rounding prompts (ADR 0051 part 3). See the English module for why each clause is written whole. */
export const roundClauses: Record<number, string> = {
    [-1]: 'au dixième le plus proche',
    0: "à l'entier le plus proche",
    1: 'à la dizaine la plus proche',
    2: 'à la centaine la plus proche',
    3: 'au millier le plus proche',
};

export const roundingPrompts = {
    round: (value: string, clause: string) => `Arrondis ${value} ${clause}.`,
};
